var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessSvg = function SvgSuccessSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#50B748",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.413 13.413c2.556 0 5.111.977 7.067 2.93a9.986 9.986 0 0 1 0 14.138 9.984 9.984 0 0 1-14.136 0 9.986 9.986 0 0 1 0-14.137 9.966 9.966 0 0 1 7.07-2.93Zm4.551 6.923a.773.773 0 0 0-.4.158l-5.617 4.213-2.603-2.602c-.565-.587-1.676.523-1.087 1.087l3.075 3.076c.274.26.694.29 1.004.072l6.15-4.613c.516-.377.198-1.38-.442-1.39a.769.769 0 0 0-.078 0l-.002-.001Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
export default SvgSuccessSvg;